export const ORGANIZATIONS_API_URL = 'ui/organization/organizations';

export const organizationsQueryKeys = {
  base: [ORGANIZATIONS_API_URL, 'organizations'],
};
